import { Component, OnInit, Input, Output, TemplateRef, ChangeDetectorRef, ViewChild, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { ProspectModel } from '../../../shared/models/ProspectModel';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../../../shared/providers/common.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { Router } from '@angular/router';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

export enum Timeline {
  BOV = 1,
  Premarketing = 2,
  Marketing = 3,
  DealMaking = 4,
  Closed = 5
}

@Component({
  selector: 'app-prospects-list',
  templateUrl: './prospects-list.component.html',
  styleUrls: ['./prospects-list.component.css']
})
export class ProspectsListComponent implements OnInit {

  @Input() propertyId: number;
  @Input() IsPortfolio: boolean;
  @Input() property: any;
  @Input() isFromDashboard: boolean;
  @Output() update = new EventEmitter();
  modalRef: BsModalRef;
  removeModalRef: BsModalRef;
  docListModel: BsModalRef;
  prospect: any;
  lstProspects = [] as ProspectModel[]
  table: DataTableDirective;
  dtOptions = {};
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  rowCount: number;
  searchText = '';
  prospects: any;
  UpdateItem: ProspectModel;
  isRemove = false as boolean;
  statusIDs = [];
  feedbackIds = [];
  //defaultStatusText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Status',
  //};
  defaultTypeSettings = {
    idField: 'id',
    textField: 'itemName',
    singleSelection: false,
    text: "Filter By Status",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1,
    enableCheckAll: false, // Disables "Select All"
    enableUncheckAll: false
  };
  defaultFeedbackSettings = {
    idField: 'id',
    textField: 'itemName',
    singleSelection: false,
    text: "Filter By Feedback",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1,
    enableCheckAll: false, // Disables "Select All"
    enableUncheckAll: false
  };
  //defaultFeedbackText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Feedback',
  //};
  statusList = [];
  feedbackList = [];
  privilageForSeller = false as boolean;
  IsAdmin = false as boolean;
  AddEditPermission = false as boolean
  IsP = false as boolean
  documentsList = [];
  user: any;
  showNodata = false as boolean;
  selectedTimelineId: number;
  timeline = Timeline;
  showNotes = false as boolean;
  propertyTypeIds: number[];
  propertysubcategories: number[];
  constructor(private modalService: BsModalService,
    private _dashboardService: DashboardService,
    public _validationService: ValidationService,
    private _toastService: ToastService,
    private _changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private _commonService: CommonService,
    private _auth: AuthenticationService,
    private loaderService: LoaderService,
    private router: Router
  ) { }
  isSeller = false;
  ngOnInit() {
    this.selectedTimelineId = this.property.PropertyStatus == 'BOV' ? this.timeline.BOV : (this.property.PropertyStatus == 'Pre-Marketing' ? this.timeline.Premarketing :
      (this.property.PropertyStatus == 'Available' || this.property.PropertyStatus == 'Not Available' ||
        this.property.PropertyStatus == 'Off-Market' ? this.timeline.Marketing :
        (this.property.PropertyStatus == 'Sold' ? this.timeline.Closed : this.timeline.DealMaking)));
    this.showNodata = this.selectedTimelineId >= this.timeline.Marketing ? false : true;
    if (this.property != null && this.property != undefined) {
      this.propertyTypeIds = this.property.AssetTypeIds != null && this.property.AssetTypeIds.length > 0 ? this.property.AssetTypeIds : [];
      this.propertysubcategories = this.property.SubcategoryIds != null && this.property.SubcategoryIds.length > 0 ? this.property.SubcategoryIds : [];
    }
    this.user = this._auth.user as any;
    this.IsAdmin = this._auth.Admin() || this._auth.SuperAdmin();
    this.isSeller = this._auth.Seller();
    this.AddEditPermission = this.IsAdmin || (this._auth.Broker() && this.property.BrokersId.includes(this.user.Id))
    this.privilageForSeller = (this.property.ShowProspectToSeller && this.property.SellerId.includes(x => x == this.user.Id));
    this._commonService.getProspectStatus().subscribe(response => {
      this.statusList = response.map(o => {
        return {
          id: o.Id, itemName: o.Description
        };
      });
    });
    this._commonService.getLookupsByTypeId(45).subscribe(response => {
      this.feedbackList = response.map(o => {
        return {
          id: o.Id, itemName: o.Description
        };
      });
    });
    this.bindTable();
  }

  onAddOrEdit(template: TemplateRef<any>, classes, prospects = null) {
    this.prospects = prospects;
    this._changeDetectorRef.detectChanges();
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  changeHighPriority(prospects) {
    if (prospects != null) {
      this._dashboardService.savePriorityForProspect(prospects.Id).subscribe(res => {
        prospects.IsHighPriority = prospects.IsHighPriority ? 0 : 1;

        if (prospects.IsHighPriority) {
          this._toastService.addToast({
            title: 'Success', msg:
              'Priority Added Successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Success', msg:
              'Priority Removed Successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        this.dtElement.dtInstance.then(x => x.draw(false));
      })
      
    }
  }

  onImportProspects(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  onClose() {
    this.modalRef.hide();
  }

  onSave(data) {
    this.onClose();
    this.dtElement.dtInstance.then(x => x.draw(false));
    this.update.emit({ id: 0 })
  }
  IsLoading = false;
  bindTable() {

    const that = this;
    let columns = [{ data: 'ModifiedDate' },
    { data: 'ModifiedDate' },
    { data: 'ProspectName', "visible": this.AddEditPermission },
    { data: 'CompanyName' },
    { data: 'OMDownloads' },
    { data: 'NDAExecuted' },
    { data: 'OfferOn' },
    { data: 'StatusName' },
    { data: 'FeedbackName' }, { data: 'Notes' }]
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          PropertyId: that.propertyId,
          ProspectStatusId: that.statusIDs.length > 0 ?
            that.statusIDs : [],
          ProspectFeedbackId: that.feedbackIds.length > 0 ?
            that.feedbackIds : []
        }
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/Property/GetAllProspectsByPrpertyId',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.lstProspects = resp.data ? resp.data : [];
            if (that.lstProspects.length > 0) {
              that.lstProspects.forEach(item => {
                if (item.Notes != null && item.Notes != '') {
                  if (item.Notes.trimEnd().length > 25) {
                    item.ShortDescription = item.Notes.slice(0, 25) + ' . . .';
                  }
                }
              });
            }
            this.rowCount = resp.recordsTotal;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: columns
    };
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  removeModel(template: TemplateRef<any>, classes, prospects) {
    this.removeModalRef = this.modalService.show(template, { class: classes });
    this.UpdateItem = Object.assign({}, prospects);
    this.UpdateItem.IsActive = true;
    this.isRemove = true;
  }

  updateCheckBox(prospects) {
    this.UpdateItem = Object.assign({}, prospects);
    this.UpdateItem.IsActive = false;
    this.isRemove = false
    this.UpdateItem.IsCheckboxUpdate = true;
    this.updateProspect();

  }

  updateProspect() {
    this.UpdateItem.CreatedBy = this.user.Id;
    this.UpdateItem.CreatedDate = this._validationService.utcify(new Date());
    this._dashboardService.saveProspects(this.UpdateItem).subscribe(res => {
      let messageSuccess = this.isRemove ? 'Prospect removed successfully' : 'Prospect saved successfully';
      let messageFail = this.isRemove ? 'Failed to remove prospect' : 'Failed to save prospect'

      if (res) {
        this._toastService.addToast({
          title: 'Success', msg:
            messageSuccess, timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
        this.dtElement.dtInstance.then(x => x.draw(false));
        this.update.emit({ id: 0 })
      }
      else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: messageFail,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    })
  }

  redrawTable() {
    this.dtElement.dtInstance.then(x => x.draw(false));
    this.update.emit({ id: 0 })
  }

  setSellerPrivilage(chkprivilageForSeller) {
    this._dashboardService.saveSellerVisibilityForProspect(this.propertyId, chkprivilageForSeller).subscribe(res => {
      console.log(res);
    })
    this.property.ShowProspectToSeller = chkprivilageForSeller;
  }

  docList(template: TemplateRef<any>, classes, prospects) {
    this.documentsList = prospects.LstDocuments;
    this.docListModel = this.modalService.show(template, { class: classes });
  }

  docClose() {
    this.docListModel.hide();
  }

  showPreviousEntries(prospectId: string, i: number) {
    if (this.lstProspects[i].PrevEntry == undefined || this.lstProspects[i].PrevEntry.length == 0) {
      this.loaderService.display(true);
      this._dashboardService.GetPrevProspectsList(this.propertyId, prospectId).subscribe(res => {
        this.lstProspects[i].PrevEntry = res;
        this.lstProspects[i].showPrevEntries = true;
        this.loaderService.display(false);
      });
    }
    else {
      this.lstProspects[i].showPrevEntries = !this.lstProspects[i].showPrevEntries;
    }
  }

  ExpandNotes() {
    this.showNotes = this.showNotes ? false : true;
  }

  FormatPhone(phone: string): string {
    if (!phone) return phone;

    const match = phone.match(/^(\d{10})(.*)/);
    if (match) {
      const phoneNumber = match[1];
      const remaining = match[2].trim();

      const formattedPhone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
      return remaining ? `${formattedPhone} ${remaining}` : formattedPhone;
    }

    // Return original string if it doesn't start with 10 digits
    return phone;
  }

}
